import { cleanRightToWork } from './right-to-work';
import { DOCUMENT_NAMES } from '@/core/field-names';

export function cleanDocument(document) {
  switch (document.name) {
    case DOCUMENT_NAMES.WORK_RIGHTS: {
      return cleanRightToWork(document);
    }
    default:
      return document;
  }
}
